export const invoiceTranslation = {
    en: {
        home: "Home",
        Subscriptions: "Subscriptions",
        invoices: "Invoices",
        addInvoice: "Add Invoice",
        addNewInvoice: "Add New Invoice",
        editInvoice: "Edit Invoice",
        updateInvoice: "Update Invoice",
        addInvoiceButton: "Add Invoice",
        Select: "Select",
        SelectUser: "Select User",
        SelectPayment: "Select Payment",
        InvoiceNumber: "Invoice Number",
        EnterInvoiceNumber: "Enter invoice number",
        TotalAmount: "Total Amount",
        SelectPaymentType: "Select Payment Type",
        UploadInvoice: "Upload Invoice",
        DragDropOrClickToUpload: "Drag & Drop or Click to Upload",
        SupportedFormats: "Supported formats: PDF, JPG, PNG",
        IssueDate: "Issue Date",
        DueDate: "Due Date",
        Status: "Status",
        Paid: "Paid",
        Unpaid: "Unpaid",
        search: "Search",
        Download: "Download",
        DownloadPDF: "Download PDF",
        DownloadExcel: "Download Excel",
        Clear: "Clear",
        ThereAreNoRecordsToDisplay: "There are no records to display",
        deleteInvoiceConfirmation: "Are you sure you want to delete invoice",
        deleteActionWarning: "This action cannot be undone.",
        Cancel: "Cancel",
        Delete: "Delete",
        UserName: "User Name",
        PaymentType: "Payment Type",
        Actions: "Actions",
        ChooseDateRangeForReport: "Choose date range for report",
        "Customer Information": "Customer Information",
        "First Name": "First Name",
        "Last Name": "Last Name",
        "Email": "Email",
        "Phone No": "Phone No",
        "Address": "Address",
        "City": "City",
        "Country": "Country",
        "Zip Code": "Zip Code",
        "Enter Last Name": "Enter Last Name",
        "Enter Email": "Enter Email",
        "Enter Phone No": "Enter Phone No",
        "Enter Address": "Enter Address",
        "Enter City": "Enter City",
        "Enter Country": "Enter Country",
        "Enter Zip Code": "Enter Zip Code",
        "Company Information": "Company Information",
        "Company Name": "Company Name",
        "Enter Company Name": "Enter Company Name",
        "Company Website": "Company Website",
        "Enter Company Website": "Enter Company Website",
        "Company Email": "Company Email",
        "Enter Company Email": "Enter Company Email",
        "Company Phone": "Company Phone",
        "Enter Company Phone": "Enter Company Phone",
        "Company VAT Number": "Company VAT Number",
        "Enter Company VAT Number": "Enter Company VAT Number",
        "Company CR Number": "Company CR Number",
        "Enter Company CR Number": "Enter Company CR Number",
        "Company Address": "Company Address",
        "Enter Company Address": "Enter Company Address",
        "Company Street": "Company Street",
        "Enter Company Street": "Enter Company Street",
        "Company City": "Company City",
        "Enter Company City": "Enter Company City",
        "Company Country": "Company Country",
        "Enter Company Country": "Enter Company Country",
        "Company Zip Code": "Company Zip Code",
        "Enter Company Zip Code": "Enter Company Zip Code",
        "Billing Information": "Billing Information",
        "Billing First Name": "Billing First Name",
        "Enter Billing First Name": "Enter Billing First Name",
        "Billing Last Name": "Billing Last Name",
        "Enter Billing Last Name": "Enter Billing Last Name",
        "Billing Email": "Billing Email",
        "Enter Billing Email": "Enter Billing Email",
        "Billing Phone": "Billing Phone",
        "Enter Billing Phone": "Enter Billing Phone",
        "Billing Company": "Billing Company",
        "Enter Billing Company": "Enter Billing Company",
        "Billing Country": "Billing Country",
        "Enter Billing Country": "Enter Billing Country",
        "Billing State": "Billing State",
        "Enter Billing State": "Enter Billing State",
        "Billing City": "Billing City",
        "Enter Billing City": "Enter Billing City",
        "Billing Address": "Billing Address",
        "Enter Billing Address": "Enter Billing Address",
        "Billing Zip Code": "Billing Zip Code",
        "Enter Billing Zip Code": "Enter Billing Zip Code",
        "Subscription Information": "Subscription Information",
        "Unit Title": "Unit Title",
        "Enter Unit Title": "Enter Unit Title",
        "Unit Quantity": "Unit Quantity",
        "Enter Unit Quantity": "Enter Unit Quantity",
        "Unit Price": "Unit Price",
        "Enter Unit Price": "Enter Unit Price",
        "Billing Cycle": "Billing Cycle",
        "Select Billing Cycle": "Select Billing Cycle",
        "Unit VAT Amount": "Unit VAT Amount",
        "Enter Unit VAT Amount": "Enter Unit VAT Amount",
        "Unit VAT Percentage": "Unit VAT Percentage",
        "Enter Unit VAT Percentage": "Enter Unit VAT Percentage",
        "Unit Sub Total with VAT": "Unit Sub Total with VAT",
        "Enter Unit Sub Total with VAT": "Enter Unit Sub Total with VAT",
        "Invoice Information": "Invoice Information",
        "Invoice Vat Percentage": "Invoice Vat Percentage",
        "Enter Invoice Vat Percentage": "Enter Invoice Vat Percentage",
        "Invoice Vat Amount": "Invoice Vat Amount",
        "Enter Invoice Vat Amount": "Enter Invoice Vat Amount",
        "Invoice Discount Percentage": "Invoice Discount Percentage",
        "Enter Invoice Discount Percentage": "Enter Invoice Discount Percentage",
        "Invoice Discount Amount": "Invoice Discount Amount",
        "Invoice Coupon Applied": "Invoice Coupon Applied",
        "Enter Invoice Coupon Applied": "Enter Invoice Coupon Applied",
        "Invoice Total": "Invoice Total",
        "Enter Invoice Total": "Enter Invoice Total",
        "Invoice Total with VAT": "Invoice Total with VAT",
        "Enter Invoice Total with VAT": "Enter Invoice Total with VAT",
        "Invoice Payment Status": "Invoice Payment Status",
        "Payment Terms": "Payment Terms",
        "Enter Payment Terms": "Enter Payment Terms",
        "Invoice Terms and Conditions": "Invoice Terms and Conditions",
        "Enter Invoice Terms and Conditions": "Enter Invoice Terms and Conditions",
        "Invoice Zatca Title": "Invoice Zatca Title",
        Invoices: "Invoices",
        "Invoices field note": "*Select an Invoice Zatca Title first to enable this field",
        "Select Invoice": "Select Invoice",
        "No eligible invoices found": "No eligible invoices found",
        "Please select an invoice": "Please select an invoice",
        "Upload QR Image": "Upload QR Image",
        "XML Link": "XML Link",
        "Upload XML Link": "Upload XML Link",
        "Fatoora Portal Status": "Fatoora Portal Status",
        "Paid Amount": "Paid Amount",
        "Enter Paid Amount": "Enter Paid Amount",
        "Remaining Amount": "Remaining Amount",
        "Enter Remaining Amount": "Enter Remaining Amount",
        "Cleared": "Cleared",
        "Not cleared": "Not cleared",
        "Payment Information": "Payment Information",
        "Select Subscription": "Select Subscription",
        "Select Payments Method": "Select Payments Method",
        "Payment Transaction ID": "Payment Transaction ID",
        "Enter Payment Transaction ID": "Enter Payment Transaction ID",
        "Select Payment Status": "Select Payment Status",
        "Failed": "Failed",
        "Pending": "Pending",
        "Completed": "Completed",
        "Choose Subscription": "Choose Subscription",
        "Invoice Link": "Invoice Link",
        "Applied": "Applied",
        "Not Applied": "Not Applied",
        "XML": "XML",
        "QR Image": "QR Image",
        "Invoice": "Invoice",
        "Please select a valid image file (png, jpg, jpeg, gif, svg, webp)": "Please select a valid image file (png, jpg, jpeg, gif, svg, webp)",
        "Please select a valid XML file (.xml)": "Please select a valid XML file (.xml)",
        "Please select a valid image (png, jpg, jpeg, gif, svg, webp) or a PDF file": "Please select a valid image (png, jpg, jpeg, gif, svg, webp) or a PDF file",
        "View Invoice": "View Invoice",
        "Download Invoice": "Download Invoice",
        "Download XML": "Download XML",
        "Download QR": "Download QR",
        "Period cycle": "Period cycle",
        "Enter Period Cycle": "Enter Period Cycle",
        "Select Subscription Start Date": "Select Subscription Start Date",
        "Select Subscription End Date": "Select Subscription End Date",
        "Date of Invoice": "Date of Invoice",
        "Select Issue Date": "Select Issue Date",
        "Select Due Date": "Select Due Date",
        "Invoice Reason": "Invoice Reason",
        "Enter Invoice Reason": "Enter Invoice Reason",
        "Invoice Status": "Invoice Status",
        "Not Paid": "Not Paid",
        "Partially Paid": "Partially Paid",
        "Refunded": "Refunded",
        "Payment Status": "Payment Status",
    },
    ar: {
        home: "الرئيسية",
        Subscriptions: "الاشتراكات",
        invoices: "الفواتير",
        addInvoice: "إضافة فاتورة",
        addNewInvoice: "إضافة فاتورة جديدة",
        editInvoice: "تعديل الفاتورة",
        updateInvoice: "تحديث الفاتورة",
        addInvoiceButton: "إضافة فاتورة",
        Select: "اختر",
        SelectUser: "اختر المستخدم",
        SelectPayment: "اختر الدفع",
        InvoiceNumber: "رقم الفاتورة",
        EnterInvoiceNumber: "أدخل رقم الفاتورة",
        TotalAmount: "المبلغ الإجمالي",
        SelectPaymentType: "اختر نوع الدفع",
        UploadInvoice: "رفع الفاتورة",
        DragDropOrClickToUpload: "اسحب وأفلت أو انقر للرفع",
        SupportedFormats: "الصيغ المدعومة: PDF, JPG, PNG",
        IssueDate: "تاريخ الإصدار",
        DueDate: "تاريخ الاستحقاق",
        Status: "الحالة",
        Paid: "مدفوع",
        Unpaid: "غير مدفوع",
        search: "بحث",
        Download: "تحميل",
        DownloadPDF: "تحميل PDF",
        DownloadExcel: "تحميل Excel",
        Clear: "مسح",
        ThereAreNoRecordsToDisplay: "لا توجد سجلات للعرض",
        deleteInvoiceConfirmation: "هل أنت متأكد أنك تريد حذف الفاتورة",
        deleteActionWarning: "لا يمكن التراجع عن هذا الإجراء.",
        Cancel: "إلغاء",
        Delete: "حذف",
        UserName: "اسم المستخدم",
        PaymentType: "نوع الدفع",
        Actions: "إجراءات",
        ChooseDateRangeForReport: "اختر نطاق التاريخ للتقرير",
        "Customer Information": "معلومات العميل",
        "First Name": "الاسم الأول",
        "Last Name": "اسم العائلة",
        "Email": "البريد الإلكتروني",
        "Phone No": "رقم الهاتف",
        "Address": "العنوان",
        "City": "المدينة",
        "Country": "الدولة",
        "Zip Code": "الرمز البريدي",
        "Enter Last Name": "أدخل اسم العائلة",
        "Enter Email": "أدخل البريد الإلكتروني",
        "Enter Phone No": "أدخل رقم الهاتف",
        "Enter Address": "أدخل العنوان",
        "Enter City": "أدخل المدينة",
        "Enter Country": "أدخل الدولة",
        "Enter Zip Code": "أدخل الرمز البريدي",
        "Company Information": "معلومات الشركة",
        "Company Name": "اسم الشركة",
        "Enter Company Name": "أدخل اسم الشركة",
        "Company Website": "موقع الشركة",
        "Enter Company Website": "أدخل موقع الشركة",
        "Company Email": "البريد الإلكتروني للشركة",
        "Enter Company Email": "أدخل البريد الإلكتروني للشركة",
        "Company Phone": "هاتف الشركة",
        "Enter Company Phone": "أدخل هاتف الشركة",
        "Company VAT Number": "رقم ضريبة القيمة المضافة للشركة",
        "Enter Company VAT Number": "أدخل رقم ضريبة القيمة المضافة للشركة",
        "Company CR Number": "رقم السجل التجاري للشركة",
        "Enter Company CR Number": "أدخل رقم السجل التجاري للشركة",
        "Company Address": "عنوان الشركة",
        "Enter Company Address": "أدخل عنوان الشركة",
        "Company Street": "شارع الشركة",
        "Enter Company Street": "أدخل شارع الشركة",
        "Company City": "مدينة الشركة",
        "Enter Company City": "أدخل مدينة الشركة",
        "Company Country": "دولة الشركة",
        "Enter Company Country": "أدخل دولة الشركة",
        "Company Zip Code": "الرمز البريدي للشركة",
        "Enter Company Zip Code": "أدخل الرمز البريدي للشركة",
        "Billing Information": "معلومات الفوترة",
        "Billing First Name": "الاسم الأول للفوترة",
        "Enter Billing First Name": "أدخل الاسم الأول للفوترة",
        "Billing Last Name": "اسم العائلة للفوترة",
        "Enter Billing Last Name": "أدخل اسم العائلة للفوترة",
        "Billing Email": "البريد الإلكتروني للفوترة",
        "Enter Billing Email": "أدخل البريد الإلكتروني للفوترة",
        "Billing Phone": "هاتف الفوترة",
        "Enter Billing Phone": "أدخل هاتف الفوترة",
        "Billing Company": "شركة الفوترة",
        "Enter Billing Company": "أدخل شركة الفوترة",
        "Billing Country": "دولة الفوترة",
        "Enter Billing Country": "أدخل دولة الفوترة",
        "Billing State": "ولاية الفوترة",
        "Enter Billing State": "أدخل ولاية الفوترة",
        "Billing City": "مدينة الفوترة",
        "Enter Billing City": "أدخل مدينة الفوترة",
        "Billing Address": "عنوان الفوترة",
        "Enter Billing Address": "أدخل عنوان الفوترة",
        "Billing Zip Code": "الرمز البريدي للفوترة",
        "Enter Billing Zip Code": "أدخل الرمز البريدي للفوترة",
        "Subscription Information": "معلومات الاشتراك",
        "Unit Title": "عنوان الوحدة",
        "Enter Unit Title": "أدخل عنوان الوحدة",
        "Unit Quantity": "كمية الوحدة",
        "Enter Unit Quantity": "أدخل كمية الوحدة",
        "Unit Price": "سعر الوحدة",
        "Enter Unit Price": "أدخل سعر الوحدة",
        "Billing Cycle": "دورة الفوترة",
        "Enter Billing Cycle": "أدخل دورة الفوترة",
        "Unit VAT Amount": "مبلغ ضريبة القيمة المضافة للوحدة",
        "Enter Unit VAT Amount": "أدخل مبلغ ضريبة القيمة المضافة للوحدة",
        "Unit VAT Percentage": "نسبة ضريبة القيمة المضافة للوحدة",
        "Enter Unit VAT Percentage": "أدخل نسبة ضريبة القيمة المضافة للوحدة",
        "Unit Sub Total with VAT": "المجموع الفرعي للوحدة مع ضريبة القيمة المضافة",
        "Enter Unit Sub Total with VAT": "أدخل المجموع الفرعي للوحدة مع ضريبة القيمة المضافة",
        "Invoice Information": "معلومات الفاتورة",
        "Invoice Vat Percentage": "نسبة ضريبة القيمة المضافة للفاتورة",
        "Enter Invoice Vat Percentage": "أدخل نسبة ضريبة القيمة المضافة للفاتورة",
        "Invoice Vat Amount": "مبلغ ضريبة القيمة المضافة للفاتورة",
        "Enter Invoice Vat Amount": "أدخل مبلغ ضريبة القيمة المضافة للفاتورة",
        "Invoice Discount Percentage": "نسبة خصم الفاتورة",
        "Enter Invoice Discount Percentage": "أدخل نسبة خصم الفاتورة",
        "Invoice Discount Amount": "مبلغ خصم الفاتورة",
        "Enter Invoice Discount Amount": "أدخل مبلغ خصم الفاتورة",
        "Invoice Coupon Applied": "كوبون الفاتورة المطبق",
        "Enter Invoice Coupon Applied": "أدخل كوبون الفاتورة المطبق",
        "Invoice Total": "إجمالي الفاتورة",
        "Enter Invoice Total": "أدخل إجمالي الفاتورة",
        "Invoice Total with VAT": "إجمالي الفاتورة مع ضريبة القيمة المضافة",
        "Enter Invoice Total with VAT": "أدخل إجمالي الفاتورة مع ضريبة القيمة المضافة",
        "Invoice Payment Status": "حالة دفع الفاتورة",
        "Enter Invoice Payment Status": "أدخل حالة دفع الفاتورة",
        "Payment Terms": "شروط الدفع",
        "Enter Payment Terms": "أدخل شروط الدفع",
        "Invoice Terms and Conditions": "شروط وأحكام الفاتورة",
        "Enter Invoice Terms and Conditions": "أدخل شروط وأحكام الفاتورة",
        "Invoice Zatca Title": "عنوان فاتورة زاتكا",
        "Enter Invoice Zatca Title": "أدخل عنوان فاتورة زاتكا",
        Invoices: "الفواتير",
        "Invoices field note": "*اختر عنوان فاتورة زاتكا أولاً لتفعيل هذا الحقل",
        "Select Invoice": "اختر الفاتورة",
        "No eligible invoices found": "لا توجد فواتير مؤهلة",
        "Please select an invoice": "يرجى اختيار فاتورة",
        "Upload QR Image": "رفع صورة QR",
        "XML Link": "رابط XML",
        "Upload XML Link": "رفع رابط XML",
        "Fatoora Portal Status": "حالة بوابة الفاتورة",
        "Enter Fatoora Portal Status": "أدخل حالة بوابة الفاتورة",
        "Paid Amount": "المبلغ المدفوع",
        "Enter Paid Amount": "أدخل المبلغ المدفوع",
        "Remaining Amount": "المبلغ المتبقي",
        "Enter Remaining Amount": "أدخل المبلغ المتبقي",
        "Cleared": "تم المسح",
        "Not cleared": "لم يتم المسح",
        "Payment Information": "معلومات الدفع",
        "Select Subscription": "اختر الاشتراك",
        "Select Payments Method": "اختر طريقة الدفع",
        "Payment Transaction ID": "معرف معاملة الدفع",
        "Enter Payment Transaction ID": "أدخل معرف معاملة الدفع",
        "Select Payment Status": "اختر حالة الدفع",
        "Failed": "فشل",
        "Pending": "قيد الانتظار",
        "Completed": "مكتمل",
        "Choose Subscription": "اختر الاشتراك",
        "Invoice Link": "رابط الفاتورة",
        "Applied": "تم التطبيق",
        "Not Applied": "لم يتم التطبيق",
        " XML": " XML",
        "QR Image": "صورة QR",
        "Invoice": "فاتورة",
        "Please select a valid image file (png, jpg, jpeg, gif, svg, webp)": "يرجى اختيار ملف صورة صالح (png، jpg، jpeg، gif، svg، webp)",
        "Please select a valid XML file (.xml)": "يرجى اختيار ملف XML صالح (.xml)",
        "Please select a valid image (png, jpg, jpeg, gif, svg, webp) or a PDF file": "يرجى اختيار صورة صالحة (png، jpg، jpeg، gif، svg، webp) أو ملف PDF",
        "View Invoice": "عرض الفاتورة",
        "Download Invoice": "تحميل الفاتورة",
        "Download XML": "تحميل XML",
        "Download QR": "تحميل QR",
        "Period cycle": "دورة الفترة",
        "Enter Period Cycle": "أدخل دورة الفترة",
        "Select Subscription Start Date": "اختر تاريخ بدء الاشتراك",
        "Select Subscription End Date": "اختر تاريخ انتهاء الاشتراك",
        "Date of Invoice": "تاريخ الفاتورة",
        "Select Issue Date": "اختر تاريخ الإصدار",
        "Select Due Date": "اختر تاريخ الاستحقاق",
        "Invoice Reason": "سبب الفاتورة",
        "Enter Invoice Reason": "أدخل سبب الفاتورة",
        "Invoice Status": "حالة الفاتورة",
        "Not Paid": "غير مدفوعة",
        "Partially Paid": "مدفوعة جزئياً",
        "Refunded": "تم الاسترداد",
        "Payment Status": "حالة الدفع",
    }
}